
const digest = 'd99b555f2169b088addf7574d15114956334fa9c9077653b5f716885d2e8eb21';
const classes = {"wrapper":"_wrapper_17zyu_1","start":"_start_17zyu_13","controlButtons":"_controlButtons_17zyu_20","filter":"_filter_17zyu_25","resetButton":"_resetButton_17zyu_33","end":"_end_17zyu_36"};
const css = `._wrapper_17zyu_1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid #eaedf3;
  border-top: 0;
  border-bottom: 0;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 14px 34px;
  flex-wrap: wrap;
}
._wrapper_17zyu_1 ._start_17zyu_13 {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 30px;
}
._wrapper_17zyu_1 ._start_17zyu_13 ._controlButtons_17zyu_20 {
  display: flex;
  flex-direction: row;
  gap: 16px;
}
._wrapper_17zyu_1 ._start_17zyu_13 ._filter_17zyu_25 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  max-width: 500px;
  flex-grow: 1;
}
._wrapper_17zyu_1 ._start_17zyu_13 ._filter_17zyu_25 ._resetButton_17zyu_33 {
  min-width: fit-content;
}
._wrapper_17zyu_1 ._end_17zyu_36 {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 30px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  